import _				from "lodash";

import Service			from "./../../Libs/Service";
import SetupSettings	from "./../settings/settings";

let Preview = new Service({

	Name: "Preview",

	Events: {

		//Переключение рабочей ноды: активные карты данных подменяются картами этой ноды
		"Cluster Working Node Changed": function(previousServerId, serverId) {

			this.useServer(serverId);

		}

	},

	Actions: {

		//serverId - нода, с которой пришли данные
		"CreativePreviews": function(versionPreviews, data, size, serverId) {

			_.each(versionPreviews, (versionPreviews, versionId) => {

				this.updateVersionPreviews(versionId, versionPreviews, serverId);

			});

		},

		"PreviewsByVersionByHash": function(versionsPreviewsByVersionByHash, data, size, serverId) {

			_.each(versionsPreviewsByVersionByHash, (versionPreviews, versionId) => {

				this.updateVersionPreviews(versionId, versionPreviews, serverId);

			});

		},

		"Preview": function(preview, data, size, serverId) {

			this.updatePreview(preview, data.PreviewId, serverId);

		},

		"Previews": function(previews, data, size, serverId) {

			this.setPreviews(previews, serverId);

		},

		"VersionPreviewCreated": function(data) {

			Broadcast.call("New Preview Created", [data.versionId]);

		},

		"PreviewDeleted": function(data) {

			Broadcast.call("Preview Deleted", [data.previewId]);

		}

	},

	init() {

		//Карты данных по нодам кластера: у каждой ноды своя БД, и id превью и версий
		//на разных нодах совпадают, поэтому карты разделены по нодам (Client/Libs/Service.js, getServerMap)
		this.PreviewsByServer = {};
		this.PreviewsByVersionByHashByServer = {};

		this.previewGenres = {};

		// Активные карты - карты рабочей ноды
		this.useServer(0);

	},

	// Активные карты данных рабочей ноды: при переключении ноды они подменяются ссылками на карты
	// этой ноды, поэтому код обращения к ним (Previews[id]) не меняется
	useServer(serverId) {

		serverId = serverId || 0;

		if (this.NodeServerId === serverId) return;

		this.NodeServerId = serverId;

		this.Previews = this.getServerMap(this.PreviewsByServer, serverId);
		this.PreviewsByVersionByHash = this.getServerMap(this.PreviewsByVersionByHashByServer, serverId);

	},

	updateVersionPreviews(versionId, versionPreviews, serverId) {

		serverId = serverId || this.NodeServerId;

		delete this.getServerMap(this.PreviewsByVersionByHashByServer, serverId)[versionId];

		_.each(versionPreviews, preview => {

			this.setPreview(preview, serverId);

		});

		Broadcast.call("Version Previews Changed", [versionId]);

	},

	setPreviews(previews, serverId) {

		_.each(previews, preview => {

			this.setPreview(preview, serverId);

		});

		Broadcast.call("Previews Added", []);

	},

	// serverId - нода, с которой пришли данные: пишем в карты этой ноды
	setPreview(preview, serverId) {

		serverId = serverId || this.NodeServerId;

		let previewsByVersionByHash = this.getServerMap(this.PreviewsByVersionByHashByServer, serverId);

		this.getServerMap(this.PreviewsByServer, serverId)[preview.id] = preview;

		if (!previewsByVersionByHash[preview["version_id"]]) previewsByVersionByHash[preview["version_id"]] = {};
		previewsByVersionByHash[preview["version_id"]][preview["hash"]] = preview;

		preview.createDate = new Date(preview["create_date"]);

	},

	updatePreview(preview, previewId, serverId) {

		serverId = serverId || this.NodeServerId;

		let previews = this.getServerMap(this.PreviewsByServer, serverId),
			previewsByVersionByHash = this.getServerMap(this.PreviewsByVersionByHashByServer, serverId);

		let oldPreview = previews[previewId];

		if (preview) {

			this.setPreview(preview, serverId);

		} else if (oldPreview) {

			delete previews[oldPreview.id];

			if (previewsByVersionByHash[oldPreview["version_id"]]) delete previewsByVersionByHash[oldPreview["version_id"]][oldPreview["hash"]];

		}

		if (preview || oldPreview) {

			let eventPrefixes = ["Preview"];
			if (preview?.["version_id"] === Version.SelectedVersion?.id || oldPreview?.["version_id"] === Version.SelectedVersion?.id) eventPrefixes.push("Selected Version Preview");

			this.broadcastChanges(oldPreview, preview, eventPrefixes);

		}

	},

	getPreviewIndexContent(preview) {

		if (preview.options.indexContent) return preview.options.indexContent;

		Server.sendToServer({
			UpdatePreviewIndexContent: {
				previewId: preview.id
			}
		});

		return null;

	},

	// Получение базового URL или полного URL для превью с учётом настройки previewUrl и типа превью
	getPreviewUrl(preview) {

		if (!preview) return '';

		let baseUrl = preview.settings?.previewUrl || Metadata.Config["preview-url"] || '';

		if (baseUrl && !baseUrl.endsWith('/')) baseUrl += '/';

		if (preview.settings?.previewType === 'screenshot' || preview.settings?.previewType === 'image') {

			let imageType = preview.settings?.imageType || 'png';
			let imageFileName = preview.settings?.imageFileName || `screenshot.${imageType}`;
			return `${baseUrl}${preview.hash}/${imageFileName}`;

		}

		return `${baseUrl}${preview.hash}/`;

	},

	// Получение домена (хоста) из URL превью для отображения в списке
	getPreviewDomain(preview) {

		if (!preview) return '';

		let url = preview.settings?.previewUrl || Metadata.Config["preview-url"] || '';

		if (!url) return '';

		try {

			let parsed = new URL(url);
			return parsed.host;

		} catch (e) {

			return '';

		}

	},

	getPreviewScreenshotUrl(preview) {

		if (!preview) return '';

		let baseUrl = preview.settings?.previewUrl || Metadata.Config["preview-url"] || '';

		if (baseUrl && !baseUrl.endsWith('/')) baseUrl += '/';

		return `${baseUrl}${preview.hash}/screenshot.png?v=` + (preview.options?.screenshotExist || 0);

	},

	getPreviewVideoUrl(preview) {

		if (!preview) return '';

		let baseUrl = preview.settings?.previewUrl || Metadata.Config["preview-url"] || '';

		if (baseUrl && !baseUrl.endsWith('/')) baseUrl += '/';

		return `${baseUrl}${preview.hash}/${preview.options?.videoFile || 'video.webm'}?v=` + (preview.options?.videoExist || 0);

	}

});

window.Preview = Preview;

export { Preview }

